import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  organisationId: string;
}

type Result = {};

const options: ApiOptions = {
  method: 'patch',
  urlPath: '/organisation/activate',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useOrganisationActivateLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useOrganisationActivateLazy;
